import * as ReactRedux from 'react-redux'
import * as ReactRouter from 'react-router-dom'
import * as Urql from 'urql'
import * as React from 'react'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'
import * as I18n from '@rushplay/i18n'
import styled from '@emotion/styled'

import * as Session from './session'
import { Clock } from './clock'
import { useGameInfoUrlQuery } from './use-game-info-url-query'

const ModeLink = styled.div`
  opacity: ${props => (props.active ? 1 : 0.5)};
  transition: opacity 75ms ease-in;

  &:hover {
    opacity: 1;
  }
`

const getGame = `
  query Game($id: ID!) {
    game(id: $id) {
      blitzEnabled,
      displayProvider
      id
      provider
      title
    }
  }
`

export function GameWrapper(props) {
  const i18n = I18n.useI18n()
  const { mode, referrerUrl } = useGameInfoUrlQuery()
  const { gameId } = ReactRouter.useParams()
  // TODO: get from GQL
  const authenticated = ReactRedux.useSelector(state =>
    Session.isAuthenticated(state.session)
  )

  const [response] = Urql.useQuery({
    query: getGame,
    variables: { id: gameId },
  })

  const game = response?.data?.game || {}

  return (
    <Common.Box
      flexGrow="1"
      flexShrink="1"
      flexBasis="0"
      display="flex"
      flexDirection="column"
    >
      <Common.Box
        display="flex"
        justifyContent={
          !response.fetching && !response.error ? 'space-between' : 'flex-end'
        }
        py={0}
        px={[0, 1]}
        backgroundColor="footer-background"
        borderBottom="1px solid"
        borderColor="rgba(250, 255, 255, 0.2)"
        fontSize={2}
      >
        {!response.fetching && !response.error && (
          <React.Fragment>
            {authenticated && game.blitzEnabled ? (
              <Common.Box color="g-text" display="flex">
                <Common.Box pr={0} opacity="0.5">
                  {i18n.translate('game-wrapper.mode.title')}
                </Common.Box>
                <ReactRouter.Link to={`?referrer=${referrerUrl}&mode=blitz`}>
                  <ModeLink active={mode === 'blitz'}>
                    {i18n.translate('game-wrapper.mode.blitz')}
                  </ModeLink>
                </ReactRouter.Link>
                <Common.Box opacity="0.5" px={0}>
                  |
                </Common.Box>
                <ReactRouter.Link to={`?referrer=${referrerUrl}&mode=classic`}>
                  <ModeLink active={mode === 'classic'}>
                    {i18n.translate('game-wrapper.mode.classic')}
                  </ModeLink>
                </ReactRouter.Link>
              </Common.Box>
            ) : (
              <Common.Box
                as="h1"
                color="g-text"
                fontSize={1}
                opacity="0.5"
                display="flex"
                alignItems="center"
              >
                {`${game.title} - ${game.displayProvider || game.provider}`}
              </Common.Box>
            )}
          </React.Fragment>
        )}
        <Common.Box opacity="0.5">
          <Clock />
        </Common.Box>
      </Common.Box>
      {props.children}
    </Common.Box>
  )
}

GameWrapper.propTypes = {
  children: PropTypes.node,
  showModeSelector: PropTypes.bool,
}
